import { BaseDynamicZoneModel } from "@models/dynamic-zones";
import { OneTileDynamicZoneModel } from "./tile-wrapper";

export enum BentoGridVariant {
  BASE = "base",
  CENTERED = "centered",
}

export interface BentoGridDynamicZoneModel extends BaseDynamicZoneModel {
  bgColor?: string;
  bentos: OneTileDynamicZoneModel[];
  variant: BentoGridVariant;
}
